<i18n>
{
  "en": {
    "logout": "Log out",
    "home": "Home",
    "menueditor": "Menu editor",
    "optimizer": "Optimizer",
    "manualConfig": "Manual config",
    "reporting": "Reporting",
    "masters": "Master data",
    "language": "Language",
    "help": "Help",
    "usersText": "Users",
    "productMaster": "Product Master",
    "eventCalendar": "Event Calendar",
    "socialMedia": "Social media"
  },
  "es": {
    "logout": "Cerrar sesión",
    "home": "Home",
    "menueditor": "Editor de menús",
    "optimizer": "Optimizador",
    "manualConfig": "Configuración manual",
    "reporting": "Informes",
    "masters": "Gestión de maestros",
    "language": "Idioma",
    "help": "Ayuda",
    "usersText": "Usuarios",
    "productMaster":  "Productos maestros",
    "eventCalendar": "Calendario de eventos",
    "socialMedia": "Redes sociales"
  }
}
</i18n>

<template>
  <fragment>
    <v-app-bar app color="primary" dark clipped-left>
      <!--    Hamburger button-->
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <!-- Client logo -->
      <img v-if="$vuetify.breakpoint.mdAndUp && clientLogo" alt="Client Logo"
             class="client-logo md"
             width="140" height="auto"
             :src="clientLogo" />
      <v-spacer/>
      <!-- Client logo -->
      <!--    DynamEat image-->
      <v-img v-if="$vuetify.breakpoint.mdAndUp" alt="DynamEat Logo"
             class="dynameat-logo shrink mr-2 md" contain
             @click="onLogoClick" transition="scale-transition" width="140"
             :src="require('@dynameat/assets/images/dynameat-logo-long.png')"/>
      <v-avatar v-else size="36" class="mx-3 dynameat-logo" @click="onLogoClick">
        <img src="@dynameat/assets/images/dynameat-logo-secondary.png" alt="DynamEatLogo">
      </v-avatar>
      <!--  /  DynamEat image-->
      <v-spacer/>
      <!--  Restaurant list -->
      <dynameat-dropdown v-if="selectedPointOfSale" :itemSelected="selectedPointOfSale"
                         element-key="guid" :dropdownStyle="'width: 120px; font-size: 12px;'"
                         element-label="name"
                         :disabled="pointOfSaleSelectorDisabled"
                         :list="pointOfSaleList" @on-select="onSelectPointOfSale"/>

      <un-notifications-center :class="notificationsIconClass"/>

      <!--  User zone -->
      <div v-show="$vuetify.breakpoint.mdAndUp" @click="onProfile">
        <profile-header-widget dense :class="profileIconClass"/>
        <v-label dark>{{ user }}</v-label>
      </div>
      <v-menu offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs}">
          <v-btn icon v-on="on" v-bind="attrs">
            <v-icon dense>fa-ellipsis-v</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-icon>
              <v-icon dense>mdi-flag</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-select class="pa-0 " style="width:100px" v-model="language" :items="languages"
                        item-text="label" item-value="value" menu-props="auto" hide-details
                        :label="languageText" @change="changeLanguage"/>
            </v-list-item-content>
          </v-list-item>
          <v-list-item key="user" v-if="$vuetify.breakpoint.smAndDown" @click="onProfile">
            <v-list-item-icon>
              <profile-header-widget/>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ user }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="userSettings ? userSettings.role === 1 : false" key="userManager" @click="onUserManagerClick">
            <v-list-item-icon>
              <v-icon dense>mdi-account-group</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('usersText') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="userSettings ? userSettings.role === 1 || userSettings.role === 0 : false" key="productMaster" @click="onProductMasterClick">
            <v-list-item-icon>
              <v-icon dense>mdi-format-list-text</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('productMaster') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="userSettings ? userSettings.role === 1 || userSettings.role === 0 : false" key="eventManager" @click="onEventManagerClick">
            <v-list-item-icon>
              <v-icon dense>mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('eventCalendar') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="userSettings ? userSettings.role === 1 || userSettings.role === 0 : false" key="socialMedia" @click="onSocialMediaManagerClick">
            <v-list-item-icon>
              <v-icon dense>mdi-link-box-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('socialMedia') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="user" key="logout" @click="logout">
            <v-list-item-icon>
              <v-icon dense>fa-sign-out-alt</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ logoutText }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <!--  /  User zone -->
    </v-app-bar>
    <v-navigation-drawer app color="primary" clipped dark v-model="drawer">
      <v-list nav dense>
        <v-list-item class="mobile_view" v-if="!this.$vuetify.breakpoint.mdAndUp" style="padding-left: 2px;">
          <v-app-bar-nav-icon style="" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          <!-- Client logo mobile -->
          <img v-if="$vuetify.breakpoint.mdAndDown && clientLogo" alt="Client Logo"
               class="client-logo md"
               width="140" height="auto"
               :src="clientLogo" />
          <!-- Client logo -->
        </v-list-item>
        <v-list-item v-for="link in links" :key="link.routeInfo.name" :disabled="link.disabled"
                     :input-value="link.active" @click="link.onClick"
                     active-class="active-nav-item">
          <v-list-item-icon>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="link.title"/>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <dynameat-help-card :visible="showHelp" @close="onCloseHelp"/>
  </fragment>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { UnNotificationsCenter } from '@ulibs/unnotificationsqueue';
import { Watch } from 'vue-property-decorator';
import { PermissionController } from '@core/permissions';
import VueRouter from 'vue-router';
import cloneDeep from 'lodash/cloneDeep';
import ProfileHeaderWidget from '@dynameat/components/ProfileHeaderWidget.vue';
import DynameatDropdown from '@dynameat/components/DynameatDropdown.vue';
import Dynameat from '@dynameat/Dynameat';
import DynameatHelpCard from '@dynameat/components/DynameatHelpCard';
import { MODULES_SETTINGS } from '@dynameat/constants';

const { isNavigationFailure, NavigationFailureType } = VueRouter;
@Component({
  components: { DynameatHelpCard, Dynameat }
})
@Components({
  DynameatDropdown, UnNotificationsCenter, ProfileHeaderWidget, DynameatHelpCard
})
@MapGetters(['pointOfSaleList', 'selectedPointOfSale', 'user', 'nextPeriod', 'userSettings'])
@MapActions(['setSelectedPointOfSaleGuid', 'resetMenuEditor', 'resetAllState',
  'updateUserSettingsLanguageRequest'])
export default class DynameatHeader extends Vue {
  mini = false

  drawer = this.$vuetify.breakpoint.mdAndUp;

  language = { label: 'Español', value: 'es' }

  showHelp = false;

  get clientLogo() {
    if (this.pointOfSaleList.length > 0) {
      return this.pointOfSaleList[0].clientLogo;
    }
    return null;
  }

  get logoutText() {
    return this.$t('logout');
  }

  get languageText() {
    return this.$t('language');
  }

  get languages() {
    return [{ label: 'Español', value: 'es' }, { label: 'English', value: 'en' }];
  }

  get notificationsIconClass() {
    if (this.$vuetify.breakpoint.mdAndDown) return 'ml-4';
    return 'mx-3';
  }

  get profileIconClass() {
    if (this.$vuetify.breakpoint.mdAndDown) return 'mx-3';
    return 'mr-3';
  }

  get dashboardRouteInfo() {
    if (this.$route.params.pointOfSaleGuid) {
      return {
        name: 'restaurant-management',
        params: { pointOfSaleGuid: this.$route.params.pointOfSaleGuid }
      };
    }
    return { name: 'dashboard' };
  }

  get optimizerRouteInfo() {
    const periodGuid = (this.nextPeriod && this.nextPeriod.guid);
    return { name: 'optimizer', params: { periodGuid } };
  }

  get optimizerProRouteInfo() {
    return { name: 'optimizer-pro' };
  }

  get manualConfigRouteInfo() {
    return { name: 'manualConfig' };
  }

  get menuEditorRouteInfo() {
    return {
      name: 'menuList',
      params: { pointOfSaleGuid: this.$route.params.pointOfSaleGuid }
    };
  }

  get reportingRouteInfo() {
    return { name: 'reporting' };
  }

  get masterRouteInfo() {
    return { name: 'masters' };
  }

  get powerBiReportingRouteInfo() {
    return { name: 'power-bi-reporting' };
  }

  get links() {
    const routes = [
      {
        title: this.$t('home'),
        icon: 'fa-home',
        routeInfo: this.dashboardRouteInfo,
        disabled: false,
        active: this.isSomeRouteActive(['restaurant-management', 'dashboard']),
        onClick: () => this.onRouteClick(this.dashboardRouteInfo)
      },
      {
        title: MODULES_SETTINGS.optimizer.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.optimizer.icon,
        routeInfo: this.optimizerRouteInfo,
        disabled: !this.$route.params.pointOfSaleGuid || !this.nextPeriod,
        active: this.isSomeRouteActive(MODULES_SETTINGS.optimizer.childrenRoutes),
        onClick: () => this.onRouteClick(this.optimizerRouteInfo)
      },
      {
        title: MODULES_SETTINGS.optimizerPro.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.optimizerPro.icon,
        routeInfo: this.optimizerProRouteInfo,
        disabled: false,
        active: this.isSomeRouteActive(MODULES_SETTINGS.optimizerPro.childrenRoutes),
        onClick: () => this.onRouteClick(this.optimizerProRouteInfo)
      },
      {
        title: MODULES_SETTINGS.manualConfig.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.manualConfig.icon,
        routeInfo: this.manualConfigRouteInfo,
        disabled: !this.$route.params.pointOfSaleGuid,
        active: this.isSomeRouteActive(MODULES_SETTINGS.manualConfig.childrenRoutes),
        onClick: () => this.onRouteClick(this.manualConfigRouteInfo)
      },
      {
        title: MODULES_SETTINGS.menuEditor.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.menuEditor.icon,
        routeInfo: this.menuEditorRouteInfo,
        disabled: !this.$route.params.pointOfSaleGuid,
        onCompleteCallback: this.resetMenuEditor,
        active: this.isSomeRouteActive(MODULES_SETTINGS.menuEditor.childrenRoutes),
        onClick: () => this.onRouteClick(this.menuEditorRouteInfo)
      },
      {
        title: MODULES_SETTINGS.reporting.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.reporting.icon,
        routeInfo: this.reportingRouteInfo,
        disabled: !this.$route.params.pointOfSaleGuid,
        active: this.isSomeRouteActive(MODULES_SETTINGS.reporting.childrenRoutes),
        onClick: () => this.onRouteClick(this.reportingRouteInfo)
      },
      {
        title: MODULES_SETTINGS.masters.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.masters.icon,
        routeInfo: this.masterRouteInfo,
        disabled: !this.$route.params.pointOfSaleGuid,
        active: this.isSomeRouteActive(MODULES_SETTINGS.masters.childrenRoutes),
        onClick: () => this.onRouteClick(this.masterRouteInfo)
      },
      {
        title: MODULES_SETTINGS.powerBiReporting.title[this.$i18n.locale],
        icon: MODULES_SETTINGS.powerBiReporting.icon,
        routeInfo: this.powerBiReportingRouteInfo,
        disabled: !this.$route.params.pointOfSaleGuid,
        active: this.isSomeRouteActive(MODULES_SETTINGS.powerBiReporting.childrenRoutes),
        onClick: () => this.onRouteClick(this.powerBiReportingRouteInfo)
      }
    ];
    const allowedRoutes = routes.filter((route) => PermissionController.getInstance().isAllowed(route.routeInfo.name));
    allowedRoutes.push({
      title: this.$t('help'),
      icon: 'mdi-help-circle-outline',
      routeInfo: { name: 'help' },
      disabled: false,
      active: false,
      onClick: this.onShowHelp
    });
    return allowedRoutes;
  }

  @Watch('drawer')
  onDrawerChange(newDrawerState) {
    localStorage.setItem('drawerState', newDrawerState);
  }

  created() {
    if (!localStorage.getItem('drawerState')) {
      this.drawer = this.$vuetify.breakpoint.mdAndUp;
    } else this.drawer = localStorage.getItem('drawerState') !== 'false';
    if (this.userSettings) {
      this.language = this.languages.find((lang) => lang.value === this.userSettings.language) || this.languages[0];
    }
  }

  async changeLanguage(language) {
    const updatedUserSettings = cloneDeep(this.userSettings);
    updatedUserSettings.language = language;
    await this.updateUserSettingsLanguageRequest(updatedUserSettings);
    this.$root.$emit('changedLanguage');
  }

  async logout() {
    await this.$store.dispatch('logout');
    this.$router.push('/login').catch((err) => {
      if (!isNavigationFailure(err, NavigationFailureType.aborted)) {
        Promise.reject(err);
      }
    });
    this.resetAllState();
  }

  onUserManagerClick() {
    // Avoid error redundant navigation to current location
    if (this.$route.name !== 'userManager') {
      this.$router.push({ name: 'userList' });
    }
  }

  onProductMasterClick() {
    // Avoid error redundant navigation to current location
    if (this.$route.name !== 'product-master-list') {
      this.$router.push({ name: 'product-master-list' });
    }
  }

  onEventManagerClick() {
    // Avoid error redundant navigation to current location
    if (this.$route.name !== 'eventManager') {
      this.$router.push({ name: 'eventList' });
    }
  }

  onSocialMediaManagerClick() {
    if (this.$route.name !== 'socialMedia') {
      this.$router.push({ name: 'socialList' });
    }
  }

  onLogoClick() {
    // Avoid error redundant navigation to current location
    if (this.$route.name !== 'dashboard') {
      this.$router.push('/').catch((err) => {
        if (!isNavigationFailure(err, NavigationFailureType.aborted)) {
          Promise.reject(err);
        }
      });
    }
  }

  onShowHelp() {
    this.showHelp = true;
  }

  onCloseHelp() {
    this.showHelp = false;
  }

  async onSelectPointOfSale(pointOfSale) {
    if (this.$router.currentRoute.name === 'dashboard') {
      await this.setSelectedPointOfSaleGuid(pointOfSale.guid);
      await this.$router.push({
        name: 'restaurant-management',
        params: { pointOfSaleGuid: pointOfSale.guid }
      });
    } else if (this.selectedPointOfSale.guid !== pointOfSale.guid) {
      try {
        await this.setSelectedPointOfSaleGuid(pointOfSale.guid);
        await this.$router.push({
          name: this.$router.currentRoute.name,
          params: { pointOfSaleGuid: pointOfSale.guid }
        });
        // eslint-disable-next-line no-empty
      } catch (e) {
      }
    }
  }

  isSomeRouteActive(routesList = []) {
    const currentRouteName = this.$route.name;
    return routesList.some((routePath) => currentRouteName === routePath);
  }

  onRouteClick(routeInfo, onCompleteCallback) {
    if (this.$route.name !== routeInfo.name && this.$route.params !== routeInfo.params) {
      this.$router.push(routeInfo, onCompleteCallback);
    }
  }

  onProfile() {
    // Avoid error redundant navigation to current location
    if (this.$route.name !== 'profile') {
      this.$router.push({ name: 'profile' });
    }
  }

  get pointOfSaleSelectorDisabled() {
    const conditions = [
      this.$route.name === 'profile',
      this.$route.name === 'completion' && !!this.$route.params.pointOfSaleGuid
    ];
    return conditions.reduce((total, curr) => total || curr, false);
  }
}
</script>

<style lang="css" scoped>
.dynameat-logo {
  cursor: pointer;
}

.client-logo {
  padding-top: 10px;
  padding-bottom: 10px;
}

@media only screen and (max-width: 960px) {
  .client-logo {
    padding-top: 0px;
    padding-bottom: 10px;
  }

  .mobile_view {
    justify-content: space-between;
  }
}

.active-nav-item {
  background-color: var(--v-secondary-base);
  transition: all 0.2s;
  color: var(--v-primary-base) !important;
  filter: brightness(1.2);
}
</style>
